module.exports = __webpack_public_path__ + "static/media/logo-login.2cf3d4d8.png";